/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { token } from '@atlaskit/tokens';

export const LoadingContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: token('space.100'),
  width: '100%',
  minHeight: '70px',
});

// Extend LoadingContainer with min-height to prevent content jumping when a user reaches
// the bottom of the InlineDialog and 'Branches/Tags/Commits' are loading.
export const SpinnerContainer = styled(LoadingContainer)({
  minHeight: '32px',
});

// Override AK's button margin in order to left-align it (has "link" appearance)
export const RefButton = styled(Button)<any>({
  '&&': {
    paddingLeft: 0,
    textAlign: 'left',
  },
  '& span': {
    marginLeft: 0,
  },
});

export const RefList = styled.ul({
  listStyle: 'none',
  paddingTop: token('space.100'),
  paddingLeft: 0,
});

export const RefListItem = styled.li({
  marginTop: 0,
  a: {
    display: 'block',
  },
});

// Set min-height to 86px to align it with the height of the LoadingContainer (minHeight 60px + margin(top+bottom) 16px)
// to avoid modalDialog jumping when switching between LoadingContainer and ScrollableContents on the Branches/Tags empty state.
export const ScrollableContents = styled.div({
  minHeight: '86px',
  maxHeight: '300px',
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
});
